@if (days$ | async; as days) {
  @if (days) {
    {{ days }} day{{ days !== 1 ? "s" : "" }} left in trial
  }
}
